// Excel-driven customer categories (do NOT include "Other" here)
// We'll append "Other" at the end in UI so it's always last.
export const CUSTOMER_CATEGORIES = [
  "Pain Relief",
  "Fever",
  "Allergy",
  "Cold & Cough",
  "Stomach & Digestion",
  "Vitamins & Daily Health",
  "Immunity Boosters",
  "Diabetes Care",
  "Heart & Blood Pressure",
  "Cholesterol & Lipid Control",
  "Kidney & Liver Health",
  "Thyroid Care",
  "Brain & Nerves / Mental Health",
  "Bone, Joint & Arthritis Care",
  "Skin & Hair Care",
  "Eye & Ear Care",
  "Respiratory Care",
  "Infections & Antibiotics",
  "Antiviral Medicines",
  "Antifungal Medicines",
  "Vaccines & Immunization",
  "Cancer Medicines",
  "Critical Care & ICU Medicines",
  "Hormones & Fertility",
  "Women's Health",
  "Pregnancy & Maternity Care",
  "Baby & Kids Care",
  "Weight Management",
  "Sexual Wellness",
  "General Health & Miscellaneous"
];
